import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component } from 'vue-property-decorator';
import Footer from '../components/Footer.vue';
import TenantSwitch from '../components/tenant-switch.vue';
import LanguageSwitch from '../components/language-switch.vue';
import AbpBase from '../lib/AbpBase';
import util from '@/lib/util';
import AppConsts from '@/lib/AppConsts';
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginModel = {
            userNameOrEmailAddress: '',
            password: '',
            rememberMe: false,
            verifyCode: ''
        };
        _this.showChangeTenant = false;
        _this.saving = false;
        _this.imgUrl = util.ApiUrl + 'Account/GraphicVerifyCode';
        _this.rules = {
            userNameOrEmailAddress: [
                { required: true, message: _this.L('UserNameRequired'), trigger: 'blur' }
            ],
            password: [
                { required: true, message: _this.L('PasswordRequired'), trigger: 'blur' }
            ]
        };
        return _this;
    }
    Login.prototype.LoginStart = function () {
        var _this = this;
        var vm = this;
        if (!this.loginModel.verifyCode) {
            this.$Message.error('请输入验证码');
            return;
        }
        this.$refs.loginform.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (valid) {
                    this.saving = true;
                    abp.ajax.post('/Account/LoginStart?verifyCode=' + vm.loginModel.verifyCode, {}, {
                        withCredentials: true
                    }).then(function (res) {
                        var result = res.data.result;
                        if (result.success) {
                            vm.login();
                        }
                        else {
                            abp.message.error(result.message);
                        }
                    }).finally(function () {
                        _this.saving = false;
                    });
                }
                return [2 /*return*/];
            });
        }); });
    };
    Login.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.$refs.loginform.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        if (valid) {
                            // this.$Message.loading({
                            //   content: 'Loading...',
                            //   duration: 0
                            // });
                            this.saving = true;
                            abp.ajax.post('/api/TokenAuth/Authenticate', this.loginModel).then(function (res) {
                                var rep = res;
                                var tokenExpireDate = _this.loginModel.rememberMe ?
                                    (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) :
                                    undefined;
                                abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
                                abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, abp.appPath);
                                sessionStorage.setItem('rememberMe', _this.loginModel.rememberMe ? '1' : '0');
                                location.reload();
                            }).catch(function (err) {
                                // console.log('----------',err)
                                // this.$Message.destroy();
                                _this.onImgRefresh();
                            }).finally(function () {
                                // this.$Message.destroy();
                                _this.saving = false;
                            });
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(Login.prototype, "tenant", {
        get: function () {
            return this.$store.state.session.tenant;
        },
        enumerable: true,
        configurable: true
    });
    Login.prototype.created = function () {
        this.showChangeTenant = abp.multiTenancy.isEnabled;
        this.onImgRefresh();
    };
    Login.prototype.userNameKeyPress = function (event) {
        if (event.keyCode == 13) {
            this.$refs.password.focus();
        }
    };
    Login.prototype.passwordKeyPress = function (event) {
        if (event.keyCode == 13) {
            this.login();
        }
    };
    Login.prototype.onImgRefresh = function () {
        var num = Math.ceil(Math.random() * 10); //生成一个随机数（防止缓存）
        this.imgUrl = util.ApiUrl + 'Account/GraphicVerifyCode?' + num;
    };
    Login = __decorate([
        Component({
            components: { Footer: Footer, TenantSwitch: TenantSwitch, LanguageSwitch: LanguageSwitch }
        })
    ], Login);
    return Login;
}(AbpBase));
export default Login;
